import styled from 'styled-components';

import { Flex, spaceMixin, token } from '@zillow/constellation';

export const StyledImageContainer = styled(Flex)`
  border-radius: ${token('radii.lg')}px ${token('radii.lg')}px 0 0;
  background-color: ${token('colors.green100')};
  border-top: ${spaceMixin('sm')} solid ${token('colors.green100')};
  border-bottom: ${spaceMixin('sm')} solid ${token('colors.green100')};
`;
